(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-zh-hero] video').forEach(function(v){
    v.muted = true; v.setAttribute('muted','');
    var p = v.play(); if(p && p.catch){ p.catch(function(){}); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-tabbed-collections"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function init(root){
      if(root.dataset.zhReady) return; root.dataset.zhReady='1';
      var tabs = root.querySelectorAll('.tab');
      var panels = root.querySelectorAll('.panel');
      tabs.forEach(function(tab){
        tab.addEventListener('click', function(){
          var target = tab.dataset.panel;
          tabs.forEach(function(t){ t.setAttribute('aria-selected', t===tab ? 'true':'false'); });
          panels.forEach(function(p){
            var on = p.id === target;
            p.classList.toggle('is-on', on);
            if(on){ p.removeAttribute('hidden'); } else { p.setAttribute('hidden',''); }
          });
        });
      });
    }
    function all(){ document.querySelectorAll('[data-zh-gear]').forEach(init); }
    if(document.readyState !== 'loading'){ all(); } else { document.addEventListener('DOMContentLoaded', all); }
    document.addEventListener('shopify:section:load', all);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-climbers"] && !Shopify.designMode) return;
  try {
    
  function zrvReveal(){
    document.querySelectorAll('[data-zrv]').forEach(function(el){
      if(el.dataset.zrvReady) return; el.dataset.zrvReady='1';
      if(!('IntersectionObserver' in window)){ el.classList.add('is-in'); return; }
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      },{threshold:.15});
      io.observe(el);
    });
  }
  if(document.readyState!=='loading'){ zrvReveal(); } else { document.addEventListener('DOMContentLoaded', zrvReveal); }
  document.addEventListener('shopify:section:load', zrvReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-ways-in"] && !Shopify.designMode) return;
  try {
    
  function zwiReveal(){
    document.querySelectorAll('[data-zwi]').forEach(function(el){
      if(el.dataset.zwiReady) return; el.dataset.zwiReady='1';
      if(!('IntersectionObserver' in window)){ el.classList.add('is-in'); return; }
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.15});
      io.observe(el);
    });
  }
  if(document.readyState!=='loading'){ zwiReveal(); } else { document.addEventListener('DOMContentLoaded', zwiReveal); }
  document.addEventListener('shopify:section:load', zwiReveal);

  } catch(e) { console.error(e); }
})();
})();
